import { ErrorResponse, FgStatusEnum, GlobalStatus, GlobalVariableValues, JobCompletedEnum, JobStatusEnum, OperationTypeEnum, SubPlantOperationStatusEnum, WorkStationTypeEnum } from "@gtpl/shared-models/common-models";
import { DeheadingValAdditionWorkStatusResponse, GradeToValAddGridDto, GradeToValAddInventory, GradeToValAdditionResponseModel, InventoryRequest, ValAddGridDto, ValAddInventoryDto, ValAdditionResponse, ValAdditionResponseModel, ValAdditionSoakingResponseModel, ValAddSoakingDto, ValAddSoakingGridDto, WorkStationIdReq, WorkStatusDto } from "@gtpl/shared-models/production-management";
import { Injectable } from "@nestjs/common";
import { InjectRepository } from "@nestjs/typeorm";
import { getManager, Raw, Repository } from "typeorm";
import { ProductionInventoryData } from "./dto/production-inventory.dto";
import { ProductionInventory } from "./entities/production-inventory.entity";
import { ProductionInventoryRepository } from "./repositories/production-inventory.repository";
import { GenericTransactionManager } from 'apps/services/backend/typeorm-transactions/generic-transaction-manager';
import { ProductionLog } from "./entities/production-log.entity";
import { ProductionLogRepository } from "./repositories/production-log.repository";
import { WorkstationsService } from "../workstations/workstations.service";
import { WorkstationRequest } from "../workstations/dto/workstation.request";
import { SaleOrderService } from "@gtpl/shared-services/sale-management";
import { saleOrderItemIdRequest } from "@gtpl/shared-models/sale-management";
import { WorkStations } from "../workstations/workstations.entity";
import { VariantOperationsService } from "../variant-operations/variant-operations.service";
import { OperationSequenceRequest } from "./dto/operation-sequence.request";
import { GradeInventoryRequest } from "./dto/grade-inventory.request";
import { UnitRequest } from "./dto/unit.id.request";
import { LotInfoRequest } from "./dto/lot-info.request";
import appSettings from "apps/services/config";
import { UnitTypeEnum } from "@gtpl/shared-models/masters";
import { UnitcodeService } from "@gtpl/shared-services/masters";
import { unitRequiest } from "@gtpl/shared-models/warehouse-management";
import { Console } from "console";
const moment = require('moment');

@Injectable()
export class ValAdditionOperationService {
  constructor(
    @InjectRepository(ProductionInventoryRepository)
    private inventoryRepository: ProductionInventoryRepository,
    private prodlogRepository: ProductionLogRepository,
    private workstationService: WorkstationsService,
    private variantOperationService: VariantOperationsService,
    private saleService: SaleOrderService,
    private unitcodeService: UnitcodeService,

  ) { }

  async AssignValadditionOperation(inputReq: ProductionInventoryData): Promise<ValAdditionResponse> {
    const manager = new GenericTransactionManager();
    console.log(inputReq);
    try {
      const checkWorkStationAvailablity = this.prodlogRepository.createQueryBuilder('production_log')
          .select('production_log.production_log_id AS productionLogId')
          .leftJoin('production_log.workstation', 'workstations')
          .where(`production_log.workstation='${inputReq.workstation}' and production_log.job_status = 'NO' and production_log.operation='${inputReq.operation}'`);
      let result = await checkWorkStationAvailablity.getRawOne();
      console.log(result);
      if(result?.productionLogId > 0 && result != undefined){
        return new ValAdditionResponse(false, 9999, 'work Station is not avaialble.', false)
      }
      else{

        let productionInventoryData
        let productionprevInventoryData
        if(inputReq.plantType === "PLANT"){
          productionprevInventoryData = await this.inventoryRepository.findOne({ where: { lotNumber: inputReq.lotNumber, subLotNumber: inputReq.subLotNumber, saleOrderId: inputReq.saleOrderId, saleOrderItemId: inputReq.saleOrderItemId, nextOperation: inputReq.operation, plantId: inputReq.plantId } });
        }
        else if(inputReq.plantType === "SUB PLANT"){
          productionprevInventoryData = await this.inventoryRepository.findOne({ where: { lotNumber: inputReq.lotNumber, subLotNumber: inputReq.subLotNumber, saleOrderId: inputReq.saleOrderId, saleOrderItemId: inputReq.saleOrderItemId, nextOperation: inputReq.operation, subPlantId: inputReq.plantId } });
        }

        if(inputReq.plantType === "PLANT"){
          productionInventoryData = await this.inventoryRepository.findOne({ where: { lotNumber: inputReq.lotNumber, subLotNumber: inputReq.subLotNumber, saleOrderId: inputReq.saleOrderId, saleOrderItemId: inputReq.saleOrderItemId, operation: inputReq.operation, plantId: inputReq.plantId } });
        }
        else if(inputReq.plantType === "SUB PLANT"){
          productionInventoryData = await this.inventoryRepository.findOne({ where: { lotNumber: inputReq.lotNumber, subLotNumber: inputReq.subLotNumber, saleOrderId: inputReq.saleOrderId, saleOrderItemId: inputReq.saleOrderItemId, operation: inputReq.operation, subPlantId: inputReq.plantId } });
        }
        let prodInvResponse;
        await manager.startTransaction();
        let plantDetails = await this.unitcodeService.getPlantDetailsById({unitcodeId:inputReq.plantId});
        if (productionInventoryData) {
          prodInvResponse = await manager.getCustomRepository(ProductionInventoryRepository).updateInventoryQuantity(inputReq,plantDetails.status?(plantDetails.data.plantType === "PLANT"?"plantId":plantDetails.data.plantType === "SUB PLANT"?"subPlantId":""):"");
          console.log(prodInvResponse)
        } else {

          const prodInv = new ProductionInventory();
          prodInv.lotNumber = inputReq.lotNumber;
          prodInv.createdUser = inputReq.createdUser;
          prodInv.subLotNumber = inputReq.subLotNumber;
          prodInv.saleOrderId = inputReq.saleOrderId;
          prodInv.saleOrderItemId = inputReq.saleOrderItemId;
          prodInv.operation = inputReq.operation;
          prodInv.operationCategory = OperationTypeEnum.VALUE_ADDITION;
          prodInv.wipQuantity = inputReq.wipQuantity;
          // prodInv.nextOperation = OperationTypeEnum.SOAKING;//need to get from varient operation master
          prodInv.inputGrade = String(inputReq.inputGrade);
          //updated actual output grade from QA/QC while sampling
          prodInv.outputGrade = String(inputReq.inputGrade);
          prodInv.boxes = inputReq.ipBoxes;
          if(inputReq.plantType === "PLANT"){
            prodInv.plantId = inputReq.plantId;
            prodInv.subPlantId = 0;
          }
          else if(inputReq.plantType === "SUB PLANT"){
            prodInv.subPlantId = inputReq.plantId;
            prodInv.plantId = productionprevInventoryData.plantId;
          }
          // prodInv.productionInventoryId = inputReq.productionInventoryId;

          // if (inputReq.subPlantId) {
          //   prodInv.subPlantId = inputReq.subPlantId;
          // }
          prodInvResponse = await manager.getCustomRepository(ProductionInventoryRepository).save(prodInv);
          console.log(prodInvResponse);
        }
        if (prodInvResponse) {

          const productionLogObj = new ProductionLog();
          productionLogObj.lotNumber = inputReq.lotNumber;
          productionLogObj.subLotNumber = inputReq.subLotNumber;
          productionLogObj.saleOrderId = inputReq.saleOrderId;
          productionLogObj.saleOrderItemId = inputReq.saleOrderItemId;
          productionLogObj.operationType = inputReq.operation;
          productionLogObj.prodInvId = inputReq.productionInvId;

          //job number genartion logic
          let today = new Date();
          let CurrentYear = today.getFullYear();
          let currentDate = today.getDate();
          // let CurrentMonth = String(today.getMonth() + 1).padStart(2, '0');
          let CurrentMonth = today.getMonth();
          let fromDate = 0;
          let toDate = 0;
          let totalRecords = await (await this.prodlogRepository.find({ where: { operationType: OperationTypeEnum.VALUE_ADDITION } })).length;
          if ((CurrentMonth+1) < 4) {
            fromDate = (CurrentYear-1);
            toDate = (CurrentYear);
          } else {
              fromDate = (CurrentYear);
              toDate = (CurrentYear + 1);
          }
          // if (CurrentMonth < 4) {
          //     fromDate = (CurrentYear);
          //     toDate = (CurrentYear + 1);
          // } else {
          //     fromDate = (CurrentYear);
          //     toDate = (CurrentYear + 1);
          // }

          totalRecords = totalRecords + 1;

          var refNo = totalRecords + "";
          while (refNo.length < 4) refNo = "0" + refNo;
          console.log(CurrentYear);
          console.log(CurrentYear.toString().substr(-2));
          console.log(CurrentMonth);
          console.log(currentDate);
          console.log(refNo);
          // const valAddJobNo = "ValAdd/" + (CurrentYear.toString().substr(-2)) + CurrentMonth + currentDate + refNo;
          const valAddJobNo = "ValAdd/" + (fromDate.toString().substr(-2))+"-"+(toDate.toString().substr(-2)) + "/" + refNo;

          console.log(valAddJobNo);
          productionLogObj.jobNumber = valAddJobNo;
          if(inputReq.plantType === "PLANT"){
            productionLogObj.plantId = inputReq.plantId;
            productionLogObj.subPlantId = 0;
          }
          else if(inputReq.plantType === "SUB PLANT"){
            productionLogObj.subPlantId = inputReq.plantId;
            productionLogObj.plantId = productionprevInventoryData.plantId;
          }
          // productionLogObj.plantId = inputReq.plantId;
          // if (inputReq.subPlantId) {
          //   productionLogObj.subPlantId = inputReq.subPlantId;
          // }
          productionLogObj.workStationType = inputReq.workStationType;
          productionLogObj.workstation = new WorkStations();
          productionLogObj.workstation.workstationId = inputReq.workstation;
          productionLogObj.jobStatus = JobCompletedEnum.NO;
          productionLogObj.inputGrade = String(inputReq.inputGrade);
          productionLogObj.inputQuantity = inputReq.issuedQuantity;
          productionLogObj.inputBoxes = inputReq.ipBoxes;
          productionLogObj.createdUser = inputReq.createdUser;
          productionLogObj.assignedUser = inputReq.createdUser;//need to get assigned user
          productionLogObj.shift = inputReq.shift;
          const saveProdLog = await manager.getCustomRepository(ProductionLogRepository).save(productionLogObj);
          let plantDetails = await this.unitcodeService.getPlantDetailsById({unitcodeId:inputReq.plantId});

          if (saveProdLog) {
            const updateIssuedQty = await manager.getCustomRepository(ProductionInventoryRepository).updateIssuedQty(inputReq.plantId, inputReq.operation, inputReq.lotNumber, inputReq.subLotNumber, inputReq.saleOrderId, inputReq.saleOrderItemId, inputReq.issuedQuantity,plantDetails.status?(plantDetails.data.plantType === "PLANT"?"plantId":plantDetails.data.plantType === "SUB PLANT"?"subPlantId":""):"");
            console.log(updateIssuedQty);
            if (updateIssuedQty) {
              manager.completeTransaction();
              return new ValAdditionResponse(true, 5555, 'Work station allocated and material assigned to value addition operation', true)
            } else {
              await manager.releaseTransaction();
              return new ValAdditionResponse(false, 9999, 'some thing went wrong', false)
            }
          } else {
            await manager.releaseTransaction();
            return new ValAdditionResponse(false, 9999, 'some thing went wrong', false)
          }
        } else {
          await manager.releaseTransaction();
          throw new ErrorResponse(9999, 'Failed to update');
        }
      }
    } catch (error) {
      console.log(error)
      await manager.releaseTransaction();
      throw error;
    }
  }

  // async valAdditionsWipDataa(req: InventoryRequest): Promise<ValAdditionResponseModel> {
  //   const manager = new GenericTransactionManager();
  //   try{
  //     let workstation = '';
  //     let soNumber = '';
  //     let poNumber = '';
  //     let plantDetails = await this.unitcodeService.getPlantDetailsById({unitcodeId:req.unitId});

  //     // const valAdditionsWipData = await this.prodlogRepository.find({ where: { operationType: req.operation, workStationType: WorkStationTypeEnum.INTERNAL }, relations: ['workstation'] })

      
  //     const valAdditionsWipDataQuery = this.prodlogRepository.createQueryBuilder('production_log')
  //         .select('production_log.actual_output_quantity AS actualOutputQuantity,production_log.op_boxes AS outputBoxes,production_log.production_log_id AS productionLogId,production_log.input_quantity AS inputQuantity,production_log.input_grade AS grade,production_log.ip_boxes AS inputBoxes,production_log.job_number AS jobNumber,production_log.input_quantity as quantity, production_log.actual_output_quantity as outputQuantity, production_log.wastage_quantity as wastageQuantity, production_log.lot_number as lotNumber, production_log.sub_lot_number as subLotNumber, production_log.sale_order_id as saleOrderId, production_log.sale_order_item_id as saleOrderItemId,production_log.workstation AS workstation,production_log.operation as operation, production_log.plant_id as plantId, production_log.op_boxes as opBoxes, production_log.job_status AS jobStatus,workstations.workstation_id AS workstationId, workstations.workstation AS workStation, workstations.workstation_code AS workstationCode, workstations.workstation_unit_capacity AS workstationUnitCapacity, workstations.workstation_category_id AS workstationCategoryId, workstations.unit_id AS unitId')
  //         .leftJoin('production_log.workstation', 'workstations')
  //         .where(`production_log.operation='${req.operation}' and workstation_type='${WorkStationTypeEnum.INTERNAL}' `);

  //       if(plantDetails.status){
  //         if(plantDetails.data.plantType === "PLANT"){
  //           valAdditionsWipDataQuery.andWhere(`production_log.sub_plant_id = 0 and plant_id='${req.unitId}'`);
  //         }
  //         else if(plantDetails.data.plantType === "SUB PLANT"){
  //           valAdditionsWipDataQuery.andWhere(`sub_plant_id='${req.unitId}'`);
  //         }
  //       }
  //       let valAdditionsWipData = await valAdditionsWipDataQuery.getRawMany();
    
  //     let valAddWipGridData: ValAddGridDto[] = [];
  //     for (const record of valAdditionsWipData) {
  //       //need to write map for this
  //       const soData = await this.saleService.getVarientInfoForSoItem(new saleOrderItemIdRequest(record.saleOrderItemId));
  //       const soNoData = await this.saleService.getSaleOrderFewDetailsForSoId({saleOrderId: record.saleOrderId});
  //       if (soData.status) {
  //         soNumber = soData.data.saleOrderNo;
  //       }
  //       if (soNoData) {
  //       poNumber = soNoData.poNumber
  //       }
  //       const obj = new ValAddGridDto(record.jobNumber, record.workStation, record.lotNumber, soNumber, record.inputGrade, 'PDTON', record.inputBoxes, record.inputQuantity, record.jobStatus, record.productionLogId, record.outputBoxes, record.actualOutputQuantity, record.workstationUnitCapacity,poNumber,record.saleOrderId);
  //       valAddWipGridData.push(obj);
  //     }
  //     let no_of_lots = 0;
  //     let toBeProcessedQty = 0;
  //     let valAddInventoryQty = 0;
  //     const prodInvData = await this.inventoryRepository.getInventoryData(req.operation,req.unitId);
  //     console.log(prodInvData.length)
  //     if (prodInvData.length > 0) {
  //       let lots_array
  //       // if (prodInvData.lotNumbers) {
  //       //   lots_array = prodInvData.lotNumbers.split(',');
  //         no_of_lots = prodInvData.length > 0?prodInvData[0].totalLots:0;
  //       // }

  //       const toProcessedData = await this.inventoryRepository.gettoBeProcessedData(req.operation,req.unitId);
  //       console.log("**************toProcessedData**************");
  //       console.log(toProcessedData);
  //       toBeProcessedQty = toProcessedData != null ? toProcessedData[0].totalReportedQty: 0;
  //       valAddInventoryQty = toProcessedData != null ? prodInvData[0].totalReportedQty: 0;
  //     }
  //     const valAddWipData = new ValAddInventoryDto(no_of_lots, toBeProcessedQty, valAddInventoryQty, valAddWipGridData);
  //     return new ValAdditionResponseModel(true, 5555, 'Val addition WIP data retreived', valAddWipData);
  //   }catch (error) {
  //     await manager.releaseTransaction();
  //     throw error;
  //   }
  // }
  async valAdditionsWipData(req:InventoryRequest):Promise<ValAdditionResponseModel>{
    const manager = getManager();
    let query;
    let plantquery;
    let abstractdataQuery;
     plantquery='select plant_type from '+appSettings.masters_db+'.unitcodes where unit_code_id='+req.unitId

     const plantresult = await manager.query(plantquery)

     const grnItemColumm = GlobalVariableValues.productionVersion == 'V2' ? 'g.plant_lot_number' : 'g.lot_number'
     
    query='SELECT CONCAT(pl.lot_number,IF(g.remarks IS NOT NULL, " - " ,""),IF(g.remarks IS NOT NULL ,g.remarks , "")) as concatLotNum , so.sale_order_no AS soNumber,sk.`variant_code` AS item,soi.po_number AS poNumber,pl.actual_output_quantity AS opQuantity,pl.op_boxes AS opboxes,pl.production_log_id AS productionLogId ,pl.input_quantity AS inputQuantity,pl.input_grade AS grade,pl.ip_boxes AS boxes,pl.job_number AS jobNumber,input_quantity AS quantity,pl.actual_output_quantity AS outputQuantity,pl.wastage_quantity AS wastageQuantity,pl.lot_number AS lotNo,pl.sub_lot_number AS subLotNumber,pl.sale_order_id AS saleOrderId,pl.sale_order_item_id AS saleOrderItemId,pl.workstation AS workstation,pl.operation AS operation,pl.plant_id AS plantId,pl.op_boxes AS opBoxes,pl.job_status AS jobStatus,w.workstation_id AS workstationId,w.workstation AS workStation,w.workstation_code AS workstationCode,w.workstation_unit_capacity AS workstationUnitCapacity,w.workstation_category_id AS workstationCategoryId,w.unit_id AS unitId FROM '+appSettings.production_db+'.`production_log` pl LEFT JOIN '+appSettings.production_db+'.`workstations` w ON w.`workstation_id`=pl.`workstation` LEFT JOIN '+appSettings.sales_db+'.`so_invoice_details` soi ON soi.`sale_order_id`=pl.`sale_order_id` LEFT JOIN '+appSettings.sales_db+'.`sale_order_items` si ON si.`sale_order_item_id`=pl.`sale_order_item_id`    LEFT JOIN '+appSettings.masters_db+'.`sku_codes` sk ON sk.`sku_code_id`=si.`varient_id`    LEFT JOIN '+appSettings.sales_db+'.`sale_order` so ON so.sale_order_id=pl.sale_order_id LEFT JOIN '+appSettings.rm_procure_db +'.grn_items g ON '+grnItemColumm+' = pl.lot_number where pl.operation="'+req.operation+'" and workstation_type="INTERNAL"'

    if(plantresult[0].plant_type == UnitTypeEnum.SUB_PLANT){
      query= query+' and pl.sub_plant_id ='+req.unitId+''
    }else{
      query = query+' and pl.plant_id='+req.unitId+' and pl.sub_plant_id=0'
    }
    const result = await manager.query(query);
  abstractdataQuery=' SELECT count(lot_number) as noOfLots , sum(issued_quantity) as processedQty,sum(physical_quantity-issued_quantity) as totalReportedQty from erpx_dev_production.production_inventory p where next_operation="'+req.operation+'" '
  if(plantresult[0].plant_type == UnitTypeEnum.SUB_PLANT){
    abstractdataQuery= abstractdataQuery+' and p.sub_plant_id='+req.unitId+''
  }else{
    abstractdataQuery = abstractdataQuery+' and p.plant_id='+req.unitId+' and p.sub_plant_id=0'
  }
  const abstractqueryresult = await manager.query(abstractdataQuery)
    const data = new ValAddInventoryDto(abstractqueryresult[0].noOfLots,abstractqueryresult[0].totalReportedQty,abstractqueryresult[0].processedQty,result)
    if(result){
      console.log('hoooooooooooooooooooooooooooooooooooooooooooooooooooo')
      return new ValAdditionResponseModel(true,1111,'Data retrived Sucessfullyy..',data)
    }else{
      return new ValAdditionResponseModel(false,1111,'No Data Found')
      
    }
  }
  // async valAdditionsReportedData(plantReq: UnitRequest): Promise<ValAdditionSoakingResponseModel> {
  //   let workstation = '';
  //   let soNumber = '';
  //   let variant = '';
  //   let soakingStyle = '';
  //   let soakingTime;
  //   let saleOrderId;
  //   let poNumber = '';
  //   //need to get next operation from service OperationTypeEnum.SOAKING
  //   let valAdditionsReportedData = await this.inventoryRepository.createQueryBuilder('production_inventory').where(`production_inventory.next_operation='${OperationTypeEnum.SOAKING}' and (physical_quantity-issued_quantity-rejected_quantity-stock_transfer_qty-conversion_quantity) > 0`).getMany();
  //   // const valAdditionsReportedData = await this.inventoryRepository.find({ where: { nextOperation: OperationTypeEnum.SOAKING } })
  //   let valAddReportedGridData: ValAddSoakingGridDto[] = [];
  //   for (const record of valAdditionsReportedData) {
  //     const soData = await this.saleService.getVarientInfoForSoItem({saleOrderItemId:record.saleOrderItemId});
  //     console.log('soDatasoData'+soData.data);
  //     const poNo =  await this.saleService.getSaleOrderFewDetailsForSoId({ saleOrderId: record.saleOrderId });
  //     poNumber = poNo.poNumber
  //     saleOrderId = poNo.saleOrderId
  //     if (soData.status) {
  //       soNumber = soData.data.saleOrderNo;
  //       variant = soData.data.variantCode;
  //       soakingStyle = soData.data.soakingStyle;
  //       soakingTime = soData.data.soakingTime;
        
  //     }
  //     const obj = new ValAddSoakingGridDto(record.lotNumber, soNumber, variant, soakingStyle, soakingTime, record.physicalQuantity,record.issuedQuantity,saleOrderId,poNumber);
  //     valAddReportedGridData.push(obj);
  //   }
  //   const prodInvData = await this.inventoryRepository.getInventoryData(OperationTypeEnum.SOAKING, plantReq.unitId);
  //   let no_of_lots = 0;
  //   let toBeProcessedQty = 0;
  //   let valAddInventoryQty = 0;
  //   if (prodInvData.length) {
  //     if (prodInvData[0].lotNumbers) {

  //       const lots_array = prodInvData[0].lotNumbers.split(',');
  //       no_of_lots = lots_array.length;
  //       const toProcessedData = await this.inventoryRepository.gettoBeProcessedData(OperationTypeEnum.SOAKING, plantReq.unitId)
  //       console.log(toProcessedData);
  //       toBeProcessedQty = toProcessedData[0].totalReportedQty;
  //       valAddInventoryQty = toProcessedData[0].processedQty;
  //       no_of_lots = toProcessedData[0].noOfLots;
  //     }
  //     const valAddReportedData = new ValAddSoakingDto(no_of_lots, toBeProcessedQty, valAddInventoryQty, valAddReportedGridData);
  //     console.log(valAddReportedData);
  //     return new ValAdditionSoakingResponseModel(true, 5555, 'Val addition Reported data retreived', valAddReportedData);
  //   } else {
  //     return new ValAdditionSoakingResponseModel(false, 9999, 'No data found', undefined);

  //   }
  // }
  async valAdditionsReportedData(plantReq:UnitRequest):Promise<ValAdditionSoakingResponseModel>{
    const manager = getManager();
    let query
     query = 'SELECT soi.`soaking_time` AS soakingTime,soi.soaking_style AS soakingStyle,p.`sale_order_id`,sk.`variant_code` AS variantCode,po_number AS poNumber,lot_number AS lotNo,issued_quantity AS issuedQuantity,physical_quantity AS quantity FROM `erpx_dev_production`.`production_inventory` p LEFT JOIN `erpx_dev_sales`.`so_invoice_details` si ON p.sale_order_id=si.`sale_order_id` LEFT JOIN `erpx_dev_sales`.`sale_order_items` soi ON soi.sale_order_item_id=p.sale_order_item_id LEFT JOIN `erpx_dev_masters`.`sku_codes` sk ON sk.`sku_code_id`=soi.`varient_id` WHERE p.`next_operation`="SOAKING" AND    (physical_quantity-issued_quantity-rejected_quantity-stock_transfer_qty-conversion_quantity) > 0'
     const plantname='select plant_type from '+appSettings.masters_db+'.unitcodes where unit_code_id='+plantReq.unitId;
     const plantresult =await manager.query(plantname);

     if(plantresult[0].plant_type == UnitTypeEnum.SUB_PLANT){
      query = query+' and p.sub_plant_id='+plantReq.unitId+''
     }else{
      query = query+' and p.plant_id='+plantReq.unitId+' and p.sub_plant_id=0'
     }
   
    const result = await manager.query(query);
    let abstractQuery;
     abstractQuery = `SELECT COUNT(lot_number) AS noOfLots , SUM(issued_quantity) AS processedQty,SUM(physical_quantity-issued_quantity) AS totalReportedQty FROM erpx_dev_production.production_inventory
    WHERE next_operation='SOAKING'`
    if(plantresult[0].plant_type == UnitTypeEnum.SUB_PLANT){
      abstractQuery = abstractQuery+' production_inventory.sub_plant_id='+plantReq.unitId+''
    }else{
      abstractQuery=abstractQuery+' and production_inventory.plant_id='+plantReq.unitId+' and sub_plant_id=0'
    }
    const abstarctData = await manager.query(abstractQuery);
    const data = new ValAddSoakingDto(abstarctData[0].noOfLots,abstarctData[0].totalReportedQty,abstarctData[0].processedQty,result)
    if(result){
      return new ValAdditionSoakingResponseModel(true,1111,'Data retrived Sucessfullyy..',data)
    }else{
      return new ValAdditionSoakingResponseModel(false,1111,'Data not found',data)
    }

  }

  async valAdditionWorkStatusInfo(plantReq: UnitRequest): Promise<DeheadingValAdditionWorkStatusResponse> {
    const workstatusInfo = await this.prodlogRepository.find({ select: ['productionLogId', 'lotNumber', 'saleOrderId', 'saleOrderItemId', 'jobNumber', 'inputGrade', 'inputBoxes', 'outputBoxes', 'inputQuantity', 'actualOutputQuantity', 'operationType', 'jobStatus', 'isReceived', 'dcNumber', 'plantId', 'wastageQuantity'], where: { plantId: plantReq.unitId, workStationType: WorkStationTypeEnum.EXTERNAL, jobStatus: JobCompletedEnum.NO } });
    // get box weight 

    if (workstatusInfo) {

      const workstatusDto: WorkStatusDto[] = [];

      for (const record of workstatusInfo) {

        const req = new LotInfoRequest();
        req.lotNumber = record.lotNumber
        req.presentOperation = record.operationType;
        req.plantId = record.plantId;

        const inventoryData = await this.inventoryRepository.getLotNumberInfo(req)

        const boxWeight = inventoryData.physicalQuantity / inventoryData.boxes;
        const soInfo = await this.saleService.getSaleOrderDataForSoId({ saleOrderId: record.saleOrderId })

        const recordObj = new WorkStatusDto(record.lotNumber, record.saleOrderId, soInfo.saleOrderNumber, record.saleOrderItemId, record.jobNumber, Number(record.inputGrade), record.inputBoxes, record.outputBoxes, Math.round(record.inputQuantity), Math.round(record.actualOutputQuantity), record.operationType, record.jobStatus, record.isReceived, record.productionLogId, record.plantId, record.dcNumber, record.mrnNumber, record.subPlantId, boxWeight, Math.round(record.wastageQuantity));
        workstatusDto.push(recordObj);
      }
      const response = new DeheadingValAdditionWorkStatusResponse(true, 9998, 'Data found', workstatusDto)
      return response;
    } else {
      return new DeheadingValAdditionWorkStatusResponse(false, 9999, 'No data found', undefined)
    }
  }
  async receiveSubPlantStockInfo(plantReq: UnitRequest): Promise<DeheadingValAdditionWorkStatusResponse> {
    const workstatusInfo = await this.prodlogRepository.find({ select: ['productionLogId', 'lotNumber', 'saleOrderId', 'saleOrderItemId', 'jobNumber', 'inputGrade', 'inputBoxes', 'outputBoxes', 'inputQuantity', 'actualOutputQuantity', 'operationType', 'jobStatus', 'isReceived', 'mrnNumber', 'plantId', 'dcNumber', 'subPlantId'], where: { plantId: plantReq.unitId, workStationType: WorkStationTypeEnum.EXTERNAL, jobStatus: JobCompletedEnum.YES, isReceived: SubPlantOperationStatusEnum.IN_TRANSIT } });
    if (workstatusInfo) {
      const workstatusDto: WorkStatusDto[] = [];

      for (const record of workstatusInfo) {
        const soInfo = await this.saleService.getSaleOrderDataForSoId({ saleOrderId: record.saleOrderId })
        const recordObj = new WorkStatusDto(record.lotNumber, record.saleOrderId, soInfo.saleOrderNumber, record.saleOrderItemId, record.jobNumber, Number(record.inputGrade), record.inputBoxes, record.outputBoxes, Math.round(record.inputQuantity), Math.round(record.actualOutputQuantity), record.operationType, record.jobStatus, record.isReceived, record.productionLogId, record.plantId, record.dcNumber, record.mrnNumber, record.subPlantId);
        workstatusDto.push(recordObj);
      }
      const response = new DeheadingValAdditionWorkStatusResponse(true, 9998, 'Data found', workstatusDto)
      return response;
    } else {
      return new DeheadingValAdditionWorkStatusResponse(false, 9999, 'No data found', undefined)
    }
  }

  //updating job status in log and physical,WIP qty updation in inventory of internal value addition reporting
  async jobCompletedStatus(workstatusDto: WorkStatusDto): Promise<DeheadingValAdditionWorkStatusResponse> {
    const manager = new GenericTransactionManager();
    try {
      let nextOperation
      const getWorkCompletedQty = await this.prodlogRepository.createQueryBuilder('production_log')
        .select('production_log.sub_plant_id AS subPlantId,production_log.input_quantity as quantity, production_log.actual_output_quantity as outputQuantity, production_log.wastage_quantity as wastageQuantity, production_log.lot_number as lotNumber, production_log.sub_lot_number as subLotNumber, production_log.sale_order_id as saleOrderId, production_log.sale_order_item_id as saleOrderItemId,workstation,production_log.operation as operation, production_log.plant_id as plantId, production_log.op_boxes as opBoxes')
        .where(`production_log.production_log_id='${workstatusDto.productionLogId}'`)
        .getRawOne();
        console.log("&&&&&&&&&&&&&&&&&");
        console.log(getWorkCompletedQty)
      const inventoryData = new ProductionInventoryData();
      inventoryData.lotNumber = getWorkCompletedQty.lotNumber;
      inventoryData.subLotNumber = getWorkCompletedQty.subLotNumber;
      inventoryData.saleOrderId = getWorkCompletedQty.saleOrderId;
      inventoryData.saleOrderItemId = getWorkCompletedQty.saleOrderItemId;
      inventoryData.operation = getWorkCompletedQty.operation;
      inventoryData.plantId = getWorkCompletedQty.plantId;
      inventoryData.subPlantId = getWorkCompletedQty.subPlantId;
      inventoryData.opBoxes = workstatusDto.opBoxes;

      const opSequence = await this.variantOperationService.getOperationSequence(new OperationSequenceRequest(workstatusDto.plantId, getWorkCompletedQty.operation, getWorkCompletedQty.saleOrderItemId));
      if (opSequence.status) {
        console.log(opSequence,"333333321")
        const worksttaionData = await this.workstationService.getWorkStationsById(new WorkstationRequest(getWorkCompletedQty.workstation, workstatusDto.plantId))
        if (worksttaionData) {

          const boxWeight = worksttaionData.data.workstationUnitCapacity;
          const opQuantity = Number(workstatusDto.opBoxes * boxWeight);
          nextOperation = opSequence.data.nextOperation
          if (!(nextOperation == OperationTypeEnum.NO_OPERATION)) {
            nextOperation = opSequence.data.nextOperation;
          } else {
            nextOperation = OperationTypeEnum.NO_OPERATION
          }
          await manager.startTransaction();
          let plantDetails = await this.unitcodeService.getPlantDetailsById({unitcodeId:workstatusDto.plantId});
          const updateStatus = await manager.getCustomRepository(ProductionLogRepository).update(
            { productionLogId: Raw((alias) => `production_log_id = '${workstatusDto.productionLogId}'`) },
            { outputBoxes: workstatusDto.opBoxes, jobStatus: JobCompletedEnum.YES, actualOutputQuantity: workstatusDto.opQuantity, plannedOutputQuantity: workstatusDto.opQuantity }
          );
          console.log(updateStatus)
          if (updateStatus) {
            const jobCompletedInputQty = getWorkCompletedQty.quantity;
            const jobCompletedOutputQty = getWorkCompletedQty.outputQuantity;
            const jobCompletedWastageQty = getWorkCompletedQty.wastageQuantity;
            const updateInfo = await manager.getCustomRepository(ProductionInventoryRepository).updateInventoryPhysicalQuantity(jobCompletedInputQty, workstatusDto.opQuantity, jobCompletedWastageQty, nextOperation, inventoryData,plantDetails.status?(plantDetails.data.plantType === "PLANT"?"plantId":plantDetails.data.plantType === "SUB PLANT"?"subPlantId":""):"");
            console.log(updateInfo)
            if (updateInfo) {
              await manager.completeTransaction();

              return new DeheadingValAdditionWorkStatusResponse(true, 1111, 'Updated to completed');
            } else {
              await manager.releaseTransaction();
              throw new ErrorResponse(9999, 'Inventory updation failed');
            }

          } else {
            await manager.releaseTransaction();
            throw new ErrorResponse(9999, 'Failed to update');
          }
        } else {
          await manager.releaseTransaction();
          throw new ErrorResponse(9999, 'No workstation  found ');

        }
      } else {
        await manager.releaseTransaction();
        throw new ErrorResponse(9999, 'No operation sequence found for saleorder');
      }
    } catch (error) {
      await manager.releaseTransaction();
      throw error;
    }
  }

  //updating job status in log and physical,WIP qty updation in inventory of internal value addition reporting
  async ReportSubPlantOperation(workstatusDto: WorkStatusDto): Promise<DeheadingValAdditionWorkStatusResponse> {
    const manager = new GenericTransactionManager();
    try {
      const getWorkCompletedQty = await this.prodlogRepository.createQueryBuilder('production_log')
        .select('production_log.input_quantity as quantity, production_log.actual_output_quantity as outputQuantity, production_log.wastage_quantity as wastageQuantity, production_log.lot_number as lotNumber, production_log.sub_lot_number as subLotNumber, production_log.sale_order_id as saleOrderId, production_log.sale_order_item_id as saleOrderItemId,workstation,production_log.operation as operation, production_log.plant_id as plantId, production_log.op_boxes as opBoxes')
        .where(`production_log.production_log_id='${workstatusDto.productionLogId}'`)
        .getRawOne();
      const inventoryData = new ProductionInventoryData();
      inventoryData.lotNumber = getWorkCompletedQty.lotNumber;
      inventoryData.subLotNumber = getWorkCompletedQty.subLotNumber;
      inventoryData.saleOrderId = getWorkCompletedQty.saleOrderId;
      inventoryData.saleOrderItemId = getWorkCompletedQty.saleOrderItemId;
      inventoryData.operation = getWorkCompletedQty.operation;
      inventoryData.plantId = getWorkCompletedQty.plantId;
      inventoryData.opBoxes = getWorkCompletedQty.opBoxes;
      console.log(inventoryData);
      // const worksttaionData = await this.workstationService.getWorkStationsById(new WorkstationRequest(getWorkCompletedQty.workstation,workstatusDto.plantId))
      if (getWorkCompletedQty) {
        await manager.startTransaction();
        // check qty is reject or not 
        let updateStatus;
        if (workstatusDto.rejectedQuantity) {
          console.log(workstatusDto.rejectedQuantity)
          updateStatus = await manager.getCustomRepository(ProductionLogRepository).update(
            { productionLogId: Raw((alias) => `production_log_id = '${workstatusDto.productionLogId}'`) },
            { outputBoxes: workstatusDto.opBoxes, jobStatus: JobCompletedEnum.YES, isReceived: SubPlantOperationStatusEnum.IN_TRANSIT, rejectedQuantity: workstatusDto.rejectedQuantity, rejectionReason:workstatusDto.rejectionReason,actualOutputQuantity:workstatusDto.newOpQuantity }
          );
        } else {
          updateStatus = await manager.getCustomRepository(ProductionLogRepository).update(
            { productionLogId: Raw((alias) => `production_log_id = '${workstatusDto.productionLogId}'`) },
            { outputBoxes: workstatusDto.opBoxes, jobStatus: JobCompletedEnum.YES, isReceived: SubPlantOperationStatusEnum.IN_TRANSIT }
          );
        }
        // const boxWeight  = worksttaionData.data.workstationUnitCapacity;
        // const opQuantity = Number(workstatusDto.opBoxes*boxWeight);
        // const opQuantity = workstatusDto.opBoxes * 32;


        // update intransit quantity
        const updateIntransitQty = await manager.getCustomRepository(ProductionInventoryRepository).update({ lotNumber: inventoryData.lotNumber, subLotNumber: inventoryData.subLotNumber, saleOrderId: inventoryData.saleOrderId, saleOrderItemId: inventoryData.saleOrderItemId, operation: inventoryData.operation, plantId: inventoryData.plantId }, { wipQuantity: () => `wip_quantity-${getWorkCompletedQty.quantity}`, intransitQuantity: () => `intransit_quantity+${getWorkCompletedQty.outputQuantity}`, wastageQuantity: () => `wastage_quantity+${getWorkCompletedQty.wastageQuantity}`})

        if (updateStatus.affected && updateIntransitQty.affected) {
          await manager.completeTransaction();
          return new DeheadingValAdditionWorkStatusResponse(true, 1111, 'Updated to completed');
        } else {
          await manager.releaseTransaction();
          throw new ErrorResponse(9999, 'Failed to update');
        }
      } else {
        await manager.releaseTransaction();
        throw new ErrorResponse(9999, 'No workstation  found ');

      }

    } catch (error) {
      await manager.releaseTransaction();
      throw error;
    }
  }

  async isReceivedStatus(workstatusDto: WorkStatusDto): Promise<DeheadingValAdditionWorkStatusResponse> {
    const manager = new GenericTransactionManager();

    let nextOperation
    const getWorkCompletedQty = await this.prodlogRepository.createQueryBuilder('production_log')
      .select('production_log.input_quantity as quantity, production_log.actual_output_quantity as outputQuantity, production_log.wastage_quantity as wastageQuantity, production_log.lot_number as lotNumber, production_log.sub_lot_number as subLotNumber, production_log.sale_order_id as saleOrderId, production_log.sale_order_item_id as saleOrderItemId,workstation,production_log.operation as operation, production_log.plant_id as plantId, rejected_quantity as rejectedQuantity, production_log.op_boxes as opBoxes')
      .where(`production_log.production_log_id='${workstatusDto.productionLogId}'`)
      .getRawOne();

    const inventoryData = new ProductionInventoryData();
    inventoryData.lotNumber = getWorkCompletedQty.lotNumber;
    inventoryData.subLotNumber = getWorkCompletedQty.subLotNumber;
    inventoryData.saleOrderId = getWorkCompletedQty.saleOrderId;
    inventoryData.saleOrderItemId = getWorkCompletedQty.saleOrderItemId;
    inventoryData.operation = getWorkCompletedQty.operation;
    inventoryData.plantId = getWorkCompletedQty.plantId;
    inventoryData.rejectedQuantity = getWorkCompletedQty.rejectedQuantity;
    inventoryData.opBoxes = getWorkCompletedQty.opBoxes;

    if (OperationTypeEnum.VALUE_ADDITION == getWorkCompletedQty.operation) {
      const opSequence = await this.variantOperationService.getOperationSequence(new OperationSequenceRequest(getWorkCompletedQty.plantId, getWorkCompletedQty.operation, getWorkCompletedQty.saleOrderItemId));
      if (opSequence.status) {
        //plant id(3) need to get from frontend
        // const worksttaionData = await this.workstationService.getWorkStationsById(new WorkstationRequest(getWorkCompletedQty.workstation, 3))
        // if (worksttaionData) {
        // const boxWeight = worksttaionData.data.workstationUnitCapacity;
        // const opQuantity = Number(workstatusDto.opBoxes * boxWeight);
        nextOperation = opSequence.data.nextOperation;
        // } else {
        //   throw new ErrorResponse(9999, 'No workstation  found ');
        // }
      }
      else {
        throw new ErrorResponse(9999, 'No operation sequence found for saleorder');
      }
    } else {
      nextOperation = OperationTypeEnum.GRADING
    }

    //MRN number generation
    let today = new Date();
    let CurrentYear = today.getFullYear();
    let CurrentMonth = today.getMonth();
    let fromDate = 0;
    let toDate = 0;
    if (CurrentMonth < 4) {
      fromDate = (CurrentYear);
      toDate = (CurrentYear + 1);
    } else {
      fromDate = (CurrentYear);
      toDate = (CurrentYear + 1);
    }

    let totalExternalRecords = await (await this.prodlogRepository.find({ where: { operationType: getWorkCompletedQty.operation, workStationType: WorkStationTypeEnum.EXTERNAL, isReceived: SubPlantOperationStatusEnum.RECEIVED } })).length;


    totalExternalRecords = totalExternalRecords + 1;

    var refNo = totalExternalRecords + "";
    while (refNo.length < 4) refNo = "0" + refNo;

    const deHeadMRNNo = "DeHead/MRN/" + (fromDate.toString().substr(-2)) + "-" + (toDate.toString().substr(-2)) + "/" + refNo;

    await manager.startTransaction();
    const updateStatus = await manager.getCustomRepository(ProductionLogRepository).update(
      { productionLogId: Raw((alias) => `production_log_id = '${workstatusDto.productionLogId}'`) },
      { isReceived: SubPlantOperationStatusEnum.RECEIVED, mrnNumber: deHeadMRNNo, receivedDate: moment().format("YYYY/MM/DD") }
    );
    if (updateStatus.affected) {
      const jobCompletedInputQty = getWorkCompletedQty.quantity;
      const jobCompletedOutputQty = getWorkCompletedQty.outputQuantity;
      const jobCompletedWastageQty = getWorkCompletedQty.wastageQuantity;
      const updateInfo = await manager.getCustomRepository(ProductionInventoryRepository).updateInventoryPhysicalIntransitQuantity(jobCompletedInputQty, jobCompletedOutputQty, jobCompletedWastageQty, nextOperation, inventoryData);

      if (updateInfo) {
        await manager.completeTransaction();

        return new DeheadingValAdditionWorkStatusResponse(true, 1111, 'Updated to completed');
      } else {
        await manager.releaseTransaction();
        throw new ErrorResponse(9999, 'Inventory updation failed');
      }

    } else {
      await manager.releaseTransaction();
      throw new ErrorResponse(9999, 'Failed to update');
    }

  }


  async getGradedInventoryForValAddition(inputReq: GradeInventoryRequest): Promise<GradeToValAdditionResponseModel> {
    try {
      const manager = getManager();
      // let soNumber = '';
      // let variant = '';

      // const inventoryData = await this.inventoryRepository.getAllAvailableInventoryData(OperationTypeEnum.VALUE_ADDITION, 3)
      // const gradedInventory: GradeToValAddGridDto[] = [];
      // if (inventoryData) {

      //   for (const invRecord of inventoryData) {
      //     const soItemInfo = await this.saleService.getVarientInfoForSoItem({ saleOrderItemId: invRecord.saleOrderItemId })
      //     const soData = await this.saleService.getVarientInfoForSoItem(new saleOrderItemIdRequest(invRecord.saleOrderItemId));
      //     if (soData.status) {
      //       soNumber = soData.data.saleOrderNo;
      //       variant = soData.data.variantCode;
      //     }
          // const invObj = new GradeToValAddGridDto(invRecord.lotNumber, soNumber, invRecord.outputGrade, variant, invRecord.boxes, invRecord.physicalQuantity, invRecord.subLotNumber, invRecord.saleOrderId, invRecord.saleOrderItemId,invRecord.operation)
          
          // gradedInventory.push(invObj);
      //   }
      //   let no_of_lots = 0;
      //   let toBeProcessedQty = 0;
      //   let valAddInventoryQty = 0;
      //   const prodInvData = await this.inventoryRepository.getInventoryData(OperationTypeEnum.VALUE_ADDITION, inputReq.plantId);
      //   console.log(prodInvData);
      //   if (prodInvData) {

      //     const lots_array = prodInvData.lotNumbers.split(',');
      //     no_of_lots = lots_array.length;
      //     //plant id(3) will be send from frontend 
          // const toProcessedData = await this.inventoryRepository.gettoBeProcessedData(OperationTypeEnum.VALUE_ADDITION, inputReq.plantId)
        //   if(toProcessedData){
        //     toBeProcessedQty = toProcessedData.totalReportedQty;
        //   }
        //   valAddInventoryQty = prodInvData.totalReportedQty;
        // }
       
        // const valAddReportedData = new GradeToValAddInventory(no_of_lots, toBeProcessedQty, valAddInventoryQty, gradedInventory);
        
        const query='select plant_type from '+appSettings.masters_db+'.unitcodes where unit_code_id='+inputReq.plantId;
        const result =await manager.query(query);
        var prodInvData = `SELECT CONCAT(p.lot_number,IF(g.remarks IS NOT NULL, "-" ,""),IF(g.remarks IS NOT NULL ,g.remarks , "")) as concatLotNum, p.lot_number AS lotNumber, p.output_grade AS grade,so.sale_order_no AS soNumber,si.po_number AS poNumber , sc.variant_code AS variantCode,p.boxes,p.physical_quantity AS physicalQuantity,(p.physical_quantity-p.issued_quantity) AS quantity,p.sub_lot_number AS subLotNumber,p.sale_order_id AS saleOrderId,p.sale_order_item_id AS saleOrderItemId,p.operation,GROUP_CONCAT(DISTINCT(p.lot_number)) AS lotNumbers, p.input_grade AS inputGrade, output_grade AS outputGrade FROM ` + appSettings.production_db + `.production_inventory p
        LEFT JOIN `+ appSettings.sales_db + `.sale_order_items s ON s.sale_order_item_id = p.sale_order_item_id
        LEFT JOIN `+ appSettings.sales_db + `.sale_order so ON so.sale_order_id = s.sale_order_id
        LEFT JOIN `+ appSettings.sales_db + `.so_invoice_details si ON si.sale_order_id = s.sale_order_id
        LEFT JOIN `+ appSettings.masters_db + `.sku_codes sc ON sc.sku_code_id = s.varient_id
        LEFT JOIN `+appSettings.rm_procure_db +`.grn_items g ON g.lot_number = p.lot_number
        WHERE next_operation='${inputReq.operation}' and (physical_quantity - issued_quantity - conversion_quantity - rejected_quantity - stock_transfer_qty) > 0 ` 
        if(result[0].plant_type==UnitTypeEnum.SUB_PLANT){
          prodInvData += "AND sub_plant_id="+inputReq.plantId;
        }else{
          prodInvData += "AND plant_id="+inputReq.plantId+' and sub_plant_id = 0';
        }
        prodInvData += " group by p.prod_inv_id"
        const data=await manager.query(prodInvData);
        let abstactQuery = "Select SUM(physical_quantity) AS qtyTobeProcesed, count(lot_number) AS noOfLots,SUM(physical_quantity-issued_quantity) AS totalReportedQty  FROM " + appSettings.production_db + ".production_inventory p  where next_operation='${inputReq.operation}' and physical_quantity > issued_quantity";
        if(result[0].plant_type==UnitTypeEnum.SUB_PLANT){
          abstactQuery += " AND sub_plant_id="+inputReq.plantId;
        }else{
          abstactQuery += " AND plant_id="+inputReq.plantId+' and sub_plant_id = 0';
        }
        const abstarctData=await manager.query(abstactQuery);

        let response = new GradeToValAddInventory(abstarctData[0].noOfLots,abstarctData[0].qtyTobeProcesed,abstarctData[0].totalReportedQty, data)
        if(data.length>0){
        return new GradeToValAdditionResponseModel(true, 5555, 'Graded Inventory for value addition retreived', response);
      } else {
        return new GradeToValAdditionResponseModel(false, 9999, 'No data found', undefined);
      }
    } catch (error) {
      throw new ErrorResponse(9999, 'Failed to update');

    }
  }


}